import React, { ReactNode } from 'react';

import '@/pages/benchmark/assets/scss/page/explore/components/SearchResult.scss';

import SvgIcon from '@/pages/home/components/SvgIcon';

export default function SearchResult(props: { isHot?: boolean; isNew: boolean; title: ReactNode; type?: string; icon?: string; views?: ReactNode; }) {
  const { isHot,isNew, title, type, icon, views } = props;
  return (
    <div className="dbb-searchresult">
      {icon ? <img src={icon} className="searchresult-img" /> : <SvgIcon type={'Benchmark'} className="searchresult-img" style={{ color: '#326ff0' }} />}
      <div className="searchresult-cont">
        <div className="searchresult-title">
          <span>{title}</span>
          {
            isNew ? (
              <SvgIcon type="new2" className="searchresult-hoticon searchresult-metric-new-icon"/>
            ) : <>
              {
                isHot && (
                  <SvgIcon type="remen" className="searchresult-hoticon" />
                )
              }
            </>
          }
          {/* {isHot && <SvgIcon className="searchresult-hoticon" type="remen" />} */}
        </div>
        <div className="searchresult-desc">
          <div className="searchresult-type">{type}</div>
          {
            views && (
              <div className="searchresult-view">
                <SvgIcon className="searchresult-eyes" type="open-eyes" />
                {views}
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}
